import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from '../../../models/response/base-response';
import { IFoMonAnChiTiet } from '../../../models/response/thuc-don/IFoMonAnChiTiet';
import { eFoMonAnChiTietActionTypeIds, IFoMonAnChiTietActionTypes } from '../../action-types/thuc-don/IFoMonAnChiTietActionTypes';
import { actions } from '../../actions/actionsWrapper';


export function* foMonAnChiTietSaga(): any {
    yield takeLatest(eFoMonAnChiTietActionTypeIds.LOAD_START, loadWorker)
    yield takeLatest(eFoMonAnChiTietActionTypeIds.LOAD_COSO_START, selectByCoSoWorker)
    yield takeEvery(eFoMonAnChiTietActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eFoMonAnChiTietActionTypeIds.DELETE_START, deleteWorker)


}

function* loadWorker(): any {
    const res: IBaseResponeModel = yield call(apiWrapper.thucDonWrapper.monAnChiTiet.select_all)
    if (res.is_success) {
        yield put(actions.thucDonWrapper.monAnChiTiet.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.thucDonWrapper.monAnChiTiet.LOAD_ERROR(res.message ?? "Error"))
    }
}
function* selectByCoSoWorker(action: IFoMonAnChiTietActionTypes): any {
    const payload: number = action.payload as number;

    const res: IBaseResponeModel = yield call(apiWrapper.thucDonWrapper.monAnChiTiet.select_by_coso, payload)
    if (res.is_success) {
        yield put(actions.thucDonWrapper.monAnChiTiet.LOAD_COSO_SUCCESS(res.data))
    } else {
        yield put(actions.thucDonWrapper.monAnChiTiet.LOAD_COSO_ERROR(res.message ?? "Error"))
    }
}
function* saveWorker(action: IFoMonAnChiTietActionTypes): any {
    const payload: IFoMonAnChiTiet = action.payload as IFoMonAnChiTiet;
    let res: IBaseResponeModel;
    if (payload.id > 0) {
        res = yield call(apiWrapper.thucDonWrapper.monAnChiTiet.update, payload)
    } else {
        res = yield call(apiWrapper.thucDonWrapper.monAnChiTiet.insert, payload)
    }
    if (res.is_success) {
        yield put(actions.thucDonWrapper.monAnChiTiet.SAVE_SUCCESS(res.data))
    } else {
        yield put(actions.thucDonWrapper.monAnChiTiet.SAVE_ERROR(res.message ?? "Error"))
    }
}

function* deleteWorker(action: IFoMonAnChiTietActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.thucDonWrapper.monAnChiTiet.delete, payload)
    if (res.is_success) {
        yield put(actions.thucDonWrapper.monAnChiTiet.DELETE_SUCCESS(undefined))
    } else {
        yield put(actions.thucDonWrapper.monAnChiTiet.DELETE_ERROR(res.message ?? "Error"))
    }
}